import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { ServiceCard } from "../components/ServiceCard";
import { SERVICES } from "../lib/constants";

export default function Services() {
  useEffect(() => {
    document.title = "Our Services | KAC — Krishnaa Constructions";
  }, []);
  return (
    <>
      <section data-testid="services-hero" className="bg-brand-green py-20 md:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.28em] text-white/70">Our Services</p>
            <h1 className="mt-4 max-w-3xl font-heading text-4xl font-extrabold leading-tight tracking-tight text-white sm:text-5xl">
              All Types of Building Work.
            </h1>
            <p className="mt-5 max-w-2xl leading-relaxed text-white/85">
              Every service below is genuinely carried out by the KAC team. Choose a service to request a free quote, or get
              in touch if you need something not listed.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-brand-light/50 py-20 md:py-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {SERVICES.map((s, i) => (
              <ServiceCard key={s.id} service={s} index={i} />
            ))}
          </div>
          <Reveal className="mt-14">
            <div className="flex flex-col items-center justify-between gap-6 rounded-3xl bg-brand-green p-10 text-center sm:text-left lg:flex-row">
              <div>
                <h2 className="font-heading text-2xl font-extrabold text-white">Not sure which service you need?</h2>
                <p className="mt-2 text-white/80">Describe your project and we'll advise on the best way to tackle it — free of charge.</p>
              </div>
              <Link to="/contact" data-testid="services-quote-btn" className="inline-flex shrink-0 items-center gap-2 rounded-full bg-brand-red px-8 py-4 font-bold text-white shadow-lg transition-all hover:bg-brand-redDark active:scale-95">
                Get a Free Quote <ArrowRight className="h-5 w-5" />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
